import { render } from "./CO2.vue?vue&type=template&id=c0d58a7c"
import script from "./CO2.vue?vue&type=script&lang=js"
export * from "./CO2.vue?vue&type=script&lang=js"

import "./CO2.vue?vue&type=style&index=0&id=c0d58a7c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__